<script>
    export let message = "Loading...";
</script>

<div class="loading-overlay">
    <div class="loading-box">
        <div class="spinner"></div>
        <p class="loading-message">{message}</p>
    </div>
</div>

<style>
    .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
    }

    .loading-box {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .spinner {
        width: 48px;
        height: 48px;
        border: 5px solid rgba(0, 123, 255, 0.2);
        border-top-color: #007bff;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }

    .loading-message {
        margin-top: 12px;
        font-size: 14px;
        color: #333;
    }
</style>
